import { Injectable, computed, inject, signal } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { firstValueFrom, map } from 'rxjs';

const CHAVE_TOKEN = 'eurofarma_raizes_token';

const LOGIN = gql`
  mutation Login($usuario: String!, $senha: String!) {
    login(usuario: $usuario, senha: $senha) {
      token
      usuario
      expiresIn
    }
  }
`;

/** Lê o token de forma síncrona, sem DI — usado pelo link do Apollo. */
export function lerToken(): string | null {
  return localStorage.getItem(CHAVE_TOKEN);
}

/**
 * Autenticação da aplicação (login fixo → JWT). Diferente da SessaoService,
 * que apenas identifica o estagiário pelo nome. O JWT é anexado a todas as
 * chamadas da API (ver app.config.ts).
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private apollo = inject(Apollo);

  private readonly _token = signal<string | null>(lerToken());
  readonly token = this._token.asReadonly();
  readonly autenticado = computed(() => this._token() !== null);

  getToken(): string | null {
    return this._token();
  }

  /** Faz login; em caso de sucesso persiste o token e retorna true. */
  async login(usuario: string, senha: string): Promise<void> {
    const token = await firstValueFrom(
      this.apollo
        .mutate<{ login: { token: string } }>({
          mutation: LOGIN,
          variables: { usuario, senha },
        })
        .pipe(map((r) => r.data!.login.token)),
    );
    localStorage.setItem(CHAVE_TOKEN, token);
    this._token.set(token);
  }

  /** Encerra a autenticação (logout completo). */
  logout(): void {
    localStorage.removeItem(CHAVE_TOKEN);
    this._token.set(null);
  }
}
